import React from 'react';
import { useSelector } from 'react-redux';
import { Dialog } from 'src/components/shared/dialog/Dialog';
import { RootState } from '../../../features';
import { DreamHistoryDetail } from './DreamHistoryDetail';

export const MyIslandDreamDetailDialog: React.FC = () => {
  const { history } = useSelector((state: RootState) => state.dream);
  const { selectedUserId } = useSelector((state: RootState) => state.user);

  if (!(history.state === 'ok' && history.result.dreamLand)) {
    return <></>;
  }

  const { dreamLand, downloadCount, uploadUser } = history.result.dreamLand;

  const isSelectedUser = uploadUser.id === selectedUserId;

  return (
    <Dialog hasHeader={true} hasMenu={false}>
      <DreamHistoryDetail
        address={dreamLand.address}
        downloadCount={downloadCount}
        uploadUser={uploadUser}
        updatedAt={dreamLand.updatedAt}
        isMyIsLandDream={true}
        isSelectedUser={isSelectedUser}
      />
    </Dialog>
  );
};
